import { GrButton } from "@jnpmedi/grebob";
import { Container } from "@newLayouts/common/Container";
import { InformationGuide } from "@newComponents/layout/InformationGuide";
import { MvnMessage } from "@newLibs/utils";
import { AUTH_SUBSCRIPTION_LANG } from "@maven-msg/lang/auth";

export function EmptyOrganizations() {
  const [title, description] = MvnMessage(AUTH_SUBSCRIPTION_LANG.AUTH_SUBSCRIPTION_EMPTY_ORGANIZATION).split("\n");

  return (
    <Container excludeHomeBreadcrumb>
      <InformationGuide
        style={{ width: "100%", height: "100%", backgroundColor: "inherit" }}
        title={title}
        description={description}
        confirmButton={
          <GrButton onClick={() => window.open(`${process.env.REACT_APP_AUTH_FE_URL}/organizations`)}>
            {MvnMessage(AUTH_SUBSCRIPTION_LANG.AUTH_SUBSCRIPTION_EMPTY_ORGANIZATION_GO)}
          </GrButton>
        }
      />
    </Container>
  );
}
